export default{
    userData:null,
    didAutoLogout: false,
    logoutOverTabs:false
}